/* admin */
export const LOGOUT_REQUEST = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_FAILURE = 'REFRESH_TOKEN_FAILURE';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';

export const GET_ADMIN_LIST_REQUEST = 'GET_ADMIN_LIST_REQUEST';
export const GET_ADMIN_LIST_SUCCESS = 'GET_ADMIN_LIST_SUCCESS';
export const GET_ADMIN_LIST_FAILURE = 'GET_ADMIN_LIST_FAILURE';
export const GET_ADMIN_ROLE_LIST_REQUEST = 'GET_ADMIN_ROLE_LIST_REQUEST';
export const GET_ADMIN_ROLE_LIST_SUCCESS = 'GET_ADMIN_ROLE_LIST_SUCCESS';
export const GET_ADMIN_ROLE_LIST_FAILURE = 'GET_ADMIN_ROLE_LIST_FAILURE';
export const ADD_ADMIN_REQUEST = 'ADD_ADMIN_REQUEST';
export const ADD_ADMIN_SUCCESS = 'ADD_ADMIN_SUCCESS';
export const ADD_ADMIN_FAILURE = 'ADD_ADMIN_FAILURE';
export const EDIT_ADMIN_REQUEST = 'EDIT_ADMIN_REQUEST';
export const EDIT_ADMIN_SUCCESS = 'EDIT_ADMIN_SUCCESS';
export const EDIT_ADMIN_FAILURE = 'EDIT_ADMIN_FAILURE';
export const DELETE_ADMIN_REQUEST = 'DELETE_ADMIN_REQUEST';
export const DELETE_ADMIN_SUCCESS = 'DELETE_ADMIN_SUCCESS';
export const DELETE_ADMIN_FAILURE = 'DELETE_ADMIN_FAILURE';

/* user */
export const GET_HOTUSER_LIST_REQUEST = 'GET_HOTUSER_LIST_REQUEST';
export const GET_HOTUSER_LIST_SUCCESS = 'GET_HOTUSER_LIST_SUCCESS';
export const GET_HOTUSER_LIST_FAILURE = 'GET_HOTUSER_LIST_FAILURE';
export const ADD_HOTUSER_REQUEST = 'ADD_HOTUSER_REQUEST';
export const ADD_HOTUSER_REQUEST_SUCCESS = 'ADD_HOTUSER_REQUEST_SUCCESS';
export const ADD_HOTUSER_REQUEST_FAILURE = 'ADD_HOTUSER_REQUEST_FAILURE';
export const DELETE_HOTUSER_REQUEST = 'DELETE_HOTUSER_REQUEST';
export const DELETE_HOTUSER_REQUEST_SUCCESS = 'DELETE_HOTUSER_REQUEST_SUCCESS';
export const DELETE_HOTUSER_REQUEST_FAILURE = 'DELETE_HOTUSER_REQUEST_FAILURE';
export const SYNC_HOTUSER_REQUEST = 'SYNC_HOTUSER_REQUEST';
export const SYNC_HOTUSER_REQUEST_SUCCESS = 'SYNC_HOTUSER_REQUEST_SUCCESS';
export const SYNC_HOTUSER_REQUEST_FAILURE = 'SYNC_HOTUSER_REQUEST_FAILURE';
export const GET_USER_LIST_REQUEST = 'GET_USER_LIST_REQUEST';
export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS';
export const GET_USER_LIST_FAILURE = 'GET_USER_LIST_FAILURE';
export const SOCIAL_LOGIN_REQUEST = 'SOCIAL_LOGIN_REQUEST';
export const SOCIAL_LOGIN_SUCCESS = 'SOCIAL_LOGIN_SUCCESS';
export const SOCIAL_LOGIN_FAILURE = 'SOCIAL_LOGIN_FAILURE';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';
export const RESEND_REQUEST = 'RESEND_REQUEST';
export const RESEND_SUCCESS = 'RESEND_SUCCESS';
export const RESEND_FAILURE = 'RESEND_FAILURE';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';


// Socail
export const GET_POST_REQUEST = 'GET_POST_REQUEST';
export const GET_POST_SUCCESS = 'GET_POST_SUCCESS';
export const GET_POST_FAILURE = 'GET_POST_FAILURE';


// Game
export const GET_GAME_REQUEST = 'GET_GAME_REQUEST'
export const GET_GAME_SUCCESS = 'GET_GAME_SUCCESS'
export const GET_GAME_FAILURE = 'GET_GAME_FAILURE'
export const GET_HOTS_REQUEST = 'GET_HOTS_REQUEST'
export const GET_HOTS_SUCCESS = 'GET_HOTS_SUCCESS'
export const GET_HOTS_FAILURE = 'GET_HOTS_FAILURE'
export const GET_CHALLENGE_REQUEST = 'GET_CHALLENGE_REQUEST'
export const GET_CHALLENGE_SUCCESS = 'GET_CHALLENGE_SUCCESS'
export const GET_CHALLENGE_FAILURE = 'GET_CHALLENGE_FAILURE'

// Wall
export const GET_USER_REQUEST = 'GET_USER_REQUEST'
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_FAILURE = 'GET_USER_FAILURE'
export const GET_TRANSACTION_LIST_REQUEST = 'GET_TRANSACTION_LIST_REQUEST'
export const GET_TRANSACTION_LIST_SUCCESS = 'GET_TRANSACTION_LIST_SUCCESS'
export const GET_TRANSACTION_LIST_FAILURE = 'GET_TRANSACTION_LIST_FAILURE'

// Party
export const GET_PARTY_REQUEST = 'GET_PARTY_REQUEST'
export const GET_PARTY_SUCCESS = 'GET_PARTY_SUCCESS'
export const GET_PARTY_FAILURE = 'GET_PARTY_FAILURE'
export const PARTY_LOGIN_REQUEST = 'PARTY_LOGIN_REQUEST'
export const PARTY_LOGIN_SUCCESS = 'PARTY_LOGIN_SUCCESS'
export const PARTY_LOGIN_FAILURE = 'PARTY_LOGIN_FAILURE'
export const PARTY_LOGIN_DIRECTLY_REQUEST = 'PARTY_LOGIN_DIRECTLY_REQUEST'
export const PARTY_LOGIN_DIRECTLY_SUCCESS = 'PARTY_LOGIN_DIRECTLY_SUCCESS'
export const PARTY_LOGIN_DIRECTLY_FAILURE = 'PARTY_LOGIN_DIRECTLY_FAILURE'
export const CHECK_JOINED_REQUEST = 'CHECK_JOINED_REQUEST'
export const CHECK_JOINED_SUCCESS = 'CHECK_JOINED_SUCCESS'
export const CHECK_JOINED_FAILURE = 'CHECK_JOINED_FAILURE'
export const GET_RECORDS_REQUEST = 'GET_RECORDS_REQUEST'
export const GET_RECORDS_SUCCESS = 'GET_RECORDS_SUCCESS'
export const GET_RECORDS_FAILURE = 'GET_RECORDS_FAILURE'
export const UPLOAD_RECORD_REQUEST = 'UPLOAD_RECORD_REQUEST'
export const UPLOAD_RECORD_SUCCESS = 'UPLOAD_RECORD_SUCCESS'
export const UPLOAD_RECORD_FAILURE = 'UPLOAD_RECORD_FAILURE'
export const GET_LEADERBOARD_REQUEST = 'GET_LEADERBOARD_REQUEST'
export const GET_LEADERBOARD_SUCCESS = 'GET_LEADERBOARD_SUCCESS'
export const GET_LEADERBOARD_FAILURE = 'GET_LEADERBOARD_FAILURE'
export const GET_PARTY_RECORD_REQUEST = 'GET_PARTY_RECORD_REQUEST'
export const GET_PARTY_RECORD_SUCCESS = 'GET_PARTY_RECORD_SUCCESS'
export const GET_PARTY_RECORD_FAILURE = 'GET_PARTY_RECORD_FAILURE'
export const SYNC_PROFILE_REQUEST = 'SYNC_PROFILE_REQUEST'
export const SYNC_PROFILE_SUCCESS = 'SYNC_PROFILE_SUCCESS'
export const SYNC_PROFILE_FAILURE = 'SYNC_PROFILE_FAILURE'